import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import Popper from '@mui/material/Popper'
import IconButton from '@mui/material/Button'
import Box from "@mui/material/Box"
import ClickAwayListener from '@mui/material/ClickAwayListener'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import clockIcon from "../../assets/clockIcon.svg"
import clockIconDark from "../../assets/clockIconDark.svg"
import strokeMedium from "../../assets/strokeMedium.svg"
import strokeDark from "../../assets/strokeDark.svg"
import ApptHistory from './ApptHistory'
import CustomTextEdit from "../common/CustomTextEdit"
import PopperDataTable from './PopperDataTable'
import './StopEvents.sass'

const StopEvent = ({ event, index, edit, id, setUpdated, eventdata, setEventData, shouldEdit, userGroup, errors, setErrors, testid }) => {

    const { t } = useTranslation();

    const [openArrive, setOpenArrive] = useState(false);
    const [openDepart, setOpenDepart] = useState(false);
    const [openArrivePopper, setOpenArrivePopper] = useState(false);
    const [openDepartPopper, setOpenDepartPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [placement, setPlacement] = useState();
    const mode = event.stopType === 'pickup' ? 'arrival' : 'departure';
    // const [errors, setErrors] = useState({});

    const isEditable = React.useMemo(() => {

        return (key) => {
            const { allAccess, allowEdit, fields } = shouldEdit || {};
            const { isArrivalEventLocked, isDepartureEventLocked } = event;
            if (!edit) return false;
            if (allAccess) return true;

            const arriveKeys = [
                "apptDateTime",
                "apptReasonCode",
                "actualArrivalTimestampCarrier",
                "actualArrivalReasonCodeCarrier"
            ];

            const departKeys = [
                "actualDepartureTimestampCarrier",
                "actualDepartureReasonCodeCarrier"
            ];

            if (!allAccess && allowEdit && fields.length > 0) {
                let updatedKeys = [...fields];
                if (isArrivalEventLocked) {
                    updatedKeys = updatedKeys.filter(d => !arriveKeys.includes(d))
                }
                if (isDepartureEventLocked) {
                    updatedKeys = updatedKeys.filter(d => !departKeys.includes(d))
                }
                return updatedKeys.includes(key);
            }
            if (!allAccess && allowEdit && (isArrivalEventLocked || isDepartureEventLocked)) {
                return true;
            }
            return false
        }
    }, [edit])

    const updateEvent = (update) => {
        setEventData({
            ...eventdata,
            [event.stopNum]: {
                ...(eventdata[event.stopNum]),
                ...update
            }
        });
        setUpdated({
            ...eventdata,
            [event.stopNum]: {
                ...(eventdata[event.stopNum]),
                ...update
            }
        });
    }

    const handleClick = (newPlacement, stopType) => (event) => {
        setAnchorEl(event.currentTarget);
        if (stopType === 'arrive') setOpenArrive(previous => !previous);
        if (stopType === 'depart') setOpenDepart(previous => !previous)
        setPlacement(newPlacement);
    }

    const handleClickPopper = (newPlacement, stopType) => (event) => {
        setAnchorEl(event.currentTarget);
        if (stopType === 'arrive') setOpenArrivePopper(previous => !previous);
        if (stopType === 'depart') setOpenDepartPopper(previous => !previous);
        setPlacement(newPlacement);
    }
    

    return (
        <>
            <div key={index} className='event' data-testid="stop-event">
                <div className={event.isArrivalEventLocked ? 'stepComplete' : event.carrierUpdateLifecycleHealthArrival === 'RED' ? 'stepHighAlert' : event.carrierUpdateLifecycleHealthArrival === 'YELLOW' ? 'stepCritical' : 'notThereYet'} >
                    <Box className='arriveBox'>
                        <Typography variant='h4' pb={2} pr={2} className="stopTitle" data-testid={`${testid}-${mode}-section-title`}>
                            {event.stopType === 'pickup' ? `${t("arrive_at_pick_stop")} ${event.stopNum}` : `${t("arrive_at_drop_stop")} ${event.stopNum - 1}`}
                            {
                                (event.isArrivalEventLocked) && <Box className='lockBox' data-testid={`${testid}-${mode}-lock-icon`}>
                                    <LockOutlinedIcon fontSize="15px" />
                                </Box>
                            }
                        </Typography>
                        <div className='dataBox'>
                            <Typography variant='body2' pr={event.stopType === 'pickup' ? 21.2 : 21.7} className='textColor' data-testid={`${testid}-${mode}-location-label`}>{t("location")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-location-value`}>{event.location.id}</Typography>
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 16.2 : 13.7} data-testid={`${testid}-${mode}-pickup-drop-location-label`}>{event.stopType === 'pickup' ? t("pickup_location") : t("drop_location")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-city-state-value`}>{`${event.location.city}, ${event.location.state}`}</Typography>
                        </div>
                         <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 13.2 : 14.2} data-testid={`${testid}-${mode}-cust-appt-details-label`}>{t("cust_appt_details")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-cust-appt-details-value`}>{`${event.custApptDetails}`}</Typography>
                        </div>
                        {event.stopType === 'delivery' &&
                            <>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={9} data-testid={`${testid}-${mode}-po-pieces-lbs-label`}>{t("po_pieces_lbs")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-po-pieces-lbs-value`}>{`${event.poAndTotalPiecesLbs}`}</Typography>
                            {
                                event.poAndTotalPiecesLbsList.length > 1 && <>
                                    <IconButton
                                        // aria-describedby={id}
                                        onClick={(e) => handleClickPopper('right-start', 'arrive')(e)}
                                        data-testid='poAndTotalPiecesLbsList-arrive'
                                        className='historyButton'
                                    >
                                        <img src={openArrivePopper ? strokeDark : strokeMedium} alt="poAndTotalPiecesLbsListOpen" data-testid={`${testid}-${mode}-po-pieces-lbs-toggle-icon`} />
                                    </IconButton>
                                    {openArrivePopper && <ClickAwayListener onClickAway={() => setOpenArrivePopper(false)}>
                                        <Popper
                                            // id={id}
                                            open={openArrivePopper}
                                            anchorEl={anchorEl}
                                            placement={placement}
                                            className="appt-popper"
                                            data-testid={`${testid}-${mode}-po-pieces-lbs-panel`}
                                        >
                                            <Box className='boxStyle'>
                                                <PopperDataTable header={['poNum', 'totalPiece', 'totalLbs']} data={event.poPiecesLbs} testid={`${testid}-${mode}-po-pieces-lbs-table`} />
                                            </Box>
                                        </Popper>
                                    </ClickAwayListener>}

                                </>
                            }
                        </div>
                            </>
                        }
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={5} data-testid={`${testid}-${mode}-planned-appt-date-time-label`}>{event.stopType === 'pickup' ? t("planned_pickup_appt_date_time") : t("planned_delivery_appt_date_time")}</Typography>
                            <div className='pickUpDateTime'>
                                {
                                    !isEditable("apptDateTime") ?
                                        <>
                                            <Typography variant='subtitle1' className={event.apptDateTimeFormatted !== '-'
                                                ? 'textColor'
                                                : event.carrierUpdateLifecycleHealthArrival === 'RED'
                                                    ? 'textColorRed'
                                                    : event.carrierUpdateLifecycleHealthArrival === 'YELLOW'
                                                        ? 'textColorYellow'
                                                        : 'textColor'
                                            }
                                                data-testid={`${testid}-${mode}-appt-date-time-value`}
                                            >
                                                {
                                                    event.apptDateTimeFormatted !== '-' || (!event.isArrivalEventLocked && event.carrierUpdateLifecycleHealthArrival === 'GREEN')
                                                        ? event.apptDateTimeFormatted
                                                        : event.carrierUpdateLifecycleHealthArrival === '-'
                                                            ? '-'
                                                            : `${t('data_missing')}`
                                                }
                                            </Typography>
                                            {
                                                event?.apptHistory?.length > 0 && <>
                                                    <IconButton
                                                        // aria-describedby={id}
                                                        onClick={(e) => handleClick('right-start', 'arrive')(e)}
                                                        data-testid='apptHistory-arrive'
                                                        className='historyButton'
                                                    >
                                                        <img src={openArrive ? clockIconDark : clockIcon} alt="historyOpen" data-testid={`${testid}-${mode}-appt-history-icon`} />
                                                    </IconButton>
                                                    {openArrive && <ClickAwayListener onClickAway={() => setOpenArrive(false)}>
                                                        <Popper
                                                            // id={id}
                                                            open={openArrive}
                                                            anchorEl={anchorEl}
                                                            placement={placement}
                                                            className="appt-popper"
                                                            data-testid={`${testid}-${mode}-appt-history-panel`}
                                                        >
                                                            <Box className='boxStyle'>
                                                                <ApptHistory latestApptHistory={event?.latestApptHistory} oldApptHistory={event?.oldApptHistory} />
                                                                <Typography variant='body2' className='noteApptHistory' data-testid={`${testid}-${mode}-appt-history-note`}>{event.stopType === 'pickup' ? t('note_appt_history_pickup') : t('note_appt_history_delivery')}</Typography>
                                                            </Box>
                                                        </Popper>
                                                    </ClickAwayListener>}

                                                </>
                                            }
                                        </> :
                                        <CustomTextEdit
                                            value={event.apptDateTime}
                                            eventdata={eventdata}
                                            elementKey={"apptDateTime"}
                                            type="date"
                                            changeEvent={updateEvent}
                                            event={event}
                                            edit={edit}
                                            userGroup={userGroup}
                                            errors={errors}
                                            setErrors={setErrors}
                                            errorKey={event.stopType === 'pickup' ? "pickup_appt_reason_code" : "planned_appt_reason_code"}
                                            testid={`${testid}-${mode}-appt-date-time-input`}
                                        />
                                }
                            </div>
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={3.5} data-testid={`${testid}-${mode}-appt-reason-code-label`}>{event.stopType === 'pickup' ? t("pickup_appt_reason_code") : t("planned_appt_reason_code")}</Typography>
                            {
                                !isEditable("apptReasonCode") ?
                                    <Typography variant='subtitle1' className={event.apptReasonCodeDesc !== '-'
                                        ? 'textColor'
                                        : event.carrierUpdateLifecycleHealthArrival === 'RED' || event.isArrivalEventLocked
                                            ? 'textColorRed'
                                            : event.carrierUpdateLifecycleHealthArrival === 'YELLOW'
                                                ? 'textColorYellow'
                                                : 'textColor'
                                    } data-testid={`${testid}-${mode}-appt-reason-code-value`}>
                                        {
                                            event.apptReasonCodeDesc !== '-' || (!event.isArrivalEventLocked && event.carrierUpdateLifecycleHealthArrival === 'GREEN')
                                                ? event.apptReasonCodeDesc
                                                : event.carrierUpdateLifecycleHealthArrival === '-'
                                                    ? '-'
                                                    : `${t('data_missing')}`
                                        }
                                    </Typography> :
                                    <CustomTextEdit
                                        value={event.apptReasonCode}
                                        elementKey={"apptReasonCode"}
                                        eventdata={eventdata}
                                        type="select"
                                        changeEvent={updateEvent}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        eventName={event.stopType === 'pickup' ? "pickup_appt_reason_code" : "planned_appt_reason_code"}
                                        error={errors[event.stopType === 'pickup' ? "pickup_appt_reason_code" : "planned_appt_reason_code"]}
                                        errors={errors}
                                        setErrors={setErrors}
                                        errorKey={event.stopType === 'pickup' ? "pickup_appt_reason_code" : "planned_appt_reason_code"}
                                        testid={`${testid}-${mode}-appt-reason-code-input`}
                                    />
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 4.8 : 4.5} data-testid={`${testid}-${mode}-carrier-actual-arrival-date-time-label`}>{event.stopType === 'pickup' ? t("carrier_actual_pickup_data_time") : t("carrier_actual_delivery_data_time")}</Typography>
                            {
                                !isEditable("actualArrivalTimestampCarrier") ?
                                    <Typography variant='subtitle1' className={event.actualArrivalTimestampCarrierFormatted !== '-'
                                        ? 'textColor'
                                        : event.carrierUpdateLifecycleHealthArrival === 'RED' || event.isArrivalEventLocked
                                            ? 'textColorRed'
                                            : event.carrierUpdateLifecycleHealthArrival === 'YELLOW'
                                                ? 'textColorYellow'
                                                : 'textColor'
                                    } data-testid={`${testid}-${mode}-actual-arrival-timestamp-carrier-value`}>
                                        {
                                            event.actualArrivalTimestampCarrierFormatted !== '-' || (!event.isArrivalEventLocked && event.carrierUpdateLifecycleHealthArrival === 'GREEN')
                                                ? event.actualArrivalTimestampCarrierFormatted
                                                : event.carrierUpdateLifecycleHealthArrival === '-'
                                                    ? '-'
                                                    : `${t('data_missing')}`
                                        }
                                    </Typography> :
                                    <CustomTextEdit
                                        value={event.actualArrivalTimestampCarrier}
                                        elementKey={"actualArrivalTimestampCarrier"}
                                        type="date"
                                        changeEvent={updateEvent}
                                        eventdata={eventdata}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        errors={errors}
                                        setErrors={setErrors}
                                        // errorKey={event.stopType === 'pickup' ? "pickup_appt_reason_code" : "planned_appt_reason_code"}
                                        testid={`${testid}-${mode}-actual-arrival-timestamp-carrier-input`}
                                    />
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 3.4 : 3} data-testid={`${testid}-${mode}-carrier-actual-arrival-reason-code-label`}>{event.stopType === 'pickup' ? t("carrier_actual_pickup_reason_code") : t("carrier_actual_delivery_reason_code")}</Typography>
                            {
                                !isEditable("actualArrivalReasonCodeCarrier") ?
                                    <Typography variant='subtitle1' className={event.actualArrivalReasonCodeDescCarrier !== '-'
                                        ? 'textColor'
                                        : event.carrierUpdateLifecycleHealthArrival === 'RED' || event.isArrivalEventLocked
                                            ? 'textColorRed'
                                            : event.carrierUpdateLifecycleHealthArrival === 'YELLOW'
                                                ? 'textColorYellow'
                                                : 'textColor'
                                    } data-testid={`${testid}-${mode}-actual-arrival-reason-code-carrier-value`}>
                                        {
                                            event.actualArrivalReasonCodeDescCarrier !== '-' || (!event.isArrivalEventLocked && event.carrierUpdateLifecycleHealthArrival === 'GREEN')
                                                ? event.actualArrivalReasonCodeDescCarrier
                                                : event.carrierUpdateLifecycleHealthArrival === '-'
                                                    ? '-'
                                                    : `${t('data_missing')}`
                                        }
                                    </Typography> :
                                    <CustomTextEdit
                                        value={event.actualArrivalReasonCodeCarrier}
                                        elementKey={"actualArrivalReasonCodeCarrier"}
                                        type="select"
                                        changeEvent={updateEvent}
                                        eventdata={eventdata}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        eventName={event.stopType === 'pickup' ? "carrier_actual_pickup_reason_code" : "carrier_actual_delivery_reason_code"}
                                        setErrors={setErrors}
                                        errors={errors}
                                        testid={`${testid}-${mode}-actual-arrival-reason-code-carrier-input`}
                                    />
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 3.4 : 3.2} data-testid={`${testid}-${mode}-kc-actual-date-time-label`}>{event.stopType === 'pickup' ? t("kc_actual_date_time") : t("kc_delivery_actual_date_time")}</Typography>
                            {
                                !isEditable("actualArrivalTimestampKC") ?
                                    <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-actual-arrival-timestamp-kc-value`}>{event.actualArrivalTimestampKCFormatted}</Typography> :
                                    <CustomTextEdit
                                        value={event.actualArrivalTimestampKC}
                                        elementKey={"actualArrivalTimestampKC"}
                                        type="date"
                                        changeEvent={updateEvent}
                                        eventdata={eventdata}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        setErrors={setErrors}
                                        errors={errors}
                                        arrivalLocked={event.isArrivalEventLocked}
                                        testid={`${testid}-${mode}-actual-arrival-timestamp-kc-input`}
                                    />
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 9.7 : 9.4} data-testid={`${testid}-${mode}-final-reason-code-label`}>{event.stopType === 'pickup' ? t("final_pickup_reason_code") : t("final_delivery_reason_code")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-final-reason-code-value`}>{event.actualArrivalReasonCodeDescFinal}</Typography>
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 11.6 : 11.3} data-testid={`${testid}-${mode}-carrier-on-time-label`}>{event.stopType === 'pickup' ? t("carrier_pickup_on_time") : t("carrier_delivery_on_time")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-${mode}-carrier-on-time-value`}>{event.arrivalOnTime}</Typography>
                        </div>
                    </Box>
                </div>
                <div className={event.isDepartureEventLocked ? 'stepComplete' : event.carrierUpdateLifecycleHealthDeparture === 'RED' ? 'stepHighAlert' : event.carrierUpdateLifecycleHealthDeparture === 'YELLOW' ? 'stepCritical' : 'notThereYet'}>
                    <Box className='departBox'>
                        <Typography variant='h4' pb={2} pr={2} className="stopTitle" data-testid={`${testid}-departure-section-title`}>
                            {event.stopType === 'pickup' ? `${t("depart_from_pick_stop")} ${event.stopNum}` : `${t("depart_from_drop_stop")} ${event.stopNum - 1}`}
                            {
                                (event.isDepartureEventLocked) && <Box className='lockBox' data-testid={`${testid}-departure-lock-icon`}>
                                    <LockOutlinedIcon fontSize="15px" />
                                </Box>
                            }
                        </Typography>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 20.2 : 20.5} data-testid={`${testid}-departure-location-label`}>{t("location")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-departure-location-value`}>{event.location.id}</Typography>
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 15.2 : 12.2} data-testid={`${testid}-departure-pickup-drop-location-label`}>{event.stopType === 'pickup' ? t("pickup_location") : t("drop_location")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-departure-city-state-value`}>{`${event.location.city}, ${event.location.state}`}</Typography>
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 12.3 : 12.72} data-testid={`${testid}-departure-cust-appt-details-label`}>{t("cust_appt_details")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-departure-cust-appt-details-value`}>{`${event.custApptDetails}`}</Typography>
                        </div>
                        {event.stopType === 'delivery' &&
                            <>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={7.4} data-testid={`${testid}-departure-po-pieces-lbs-label`}>{t("po_pieces_lbs")}</Typography>
                            <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-departure-po-pieces-lbs-value`}>{`${event.poAndTotalPiecesLbs}`}</Typography>
                            {
                                event.poAndTotalPiecesLbsList.length > 1 && <>
                                    <IconButton
                                        // aria-describedby={id}
                                        onClick={(e) => handleClickPopper('right-start', 'depart')(e)}
                                        data-testid='poAndTotalPiecesLbsList-depart'
                                        className='historyButton'
                                    >
                                        <img src={openDepartPopper ? strokeDark : strokeMedium} alt="poAndTotalPiecesLbsListOpen" data-testid={`${testid}-departure-po-pieces-lbs-toggle-icon`} />
                                    </IconButton>
                                    {openDepartPopper && <ClickAwayListener onClickAway={() => setOpenDepartPopper(false)}>
                                        <Popper
                                            // id={id}
                                            open={openDepartPopper}
                                            anchorEl={anchorEl}
                                            placement={placement}
                                            className="appt-popper"
                                            data-testid={`${testid}-departure-po-pieces-lbs-panel`}
                                        >
                                            <Box className='boxStyle'>
                                                <PopperDataTable header={['poNum', 'totalPiece', 'totalLbs']} data={event.poPiecesLbs} testid={`${testid}-departure-po-pieces-lbs-table`}/>
                                            </Box>
                                        </Popper>
                                    </ClickAwayListener>}

                                </>
                            }
                        </div>
                            </>
                        }
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 9.9 : 3.5} data-testid={`${testid}-departure-planned-appt-date-time-label`}>{event.stopType === 'pickup' ? t("pickup_appt_date_time") : t("planned_delivery_appt_date_time")}</Typography>
                            <Typography variant='subtitle1' className={event.apptDateTimeFormatted !== '-'
                                ? 'textColor'
                                : event.carrierUpdateLifecycleHealthArrival === 'RED'
                                    ? 'textColorRed'
                                    : event.carrierUpdateLifecycleHealthArrival === 'YELLOW'
                                        ? 'textColorYellow'
                                        : 'textColor'
                            }
                            data-testid={`${testid}-departure-appt-date-time-value`}
                            >
                                {
                                    event.apptDateTimeFormatted !== '-' || (!event.isDepartureEventLocked && event.carrierUpdateLifecycleHealthDeparture === 'GREEN')
                                        ? event.apptDateTimeFormatted
                                        : event.carrierUpdateLifecycleHealthDeparture === '-'
                                            ? '-'
                                            : `${t('data_missing')}`
                                }
                            </Typography>
                            {event?.apptHistory?.length > 0 && <>
                                <IconButton
                                    // aria-describedby={id}
                                    onClick={(e) => handleClick('right-start', 'depart')(e)}
                                    data-testid='apptHistory-depart'
                                    className='historyButton'
                                >
                                    <img src={openDepart ? clockIconDark : clockIcon} alt="historyOpen" data-testid={`${testid}-departure-appt-history-icon`} />
                                </IconButton>
                                {openDepart && <ClickAwayListener onClickAway={() => setOpenDepart(false)}>
                                    <Popper
                                        // id={id}
                                        open={openDepart}
                                        anchorEl={anchorEl}
                                        placement={placement}
                                        className="appt-popper"
                                        data-testid={`${testid}-departure-appt-history-panel`}
                                    >
                                        <Box className='boxStyle'>
                                            <ApptHistory latestApptHistory={event.latestApptHistory} oldApptHistory={event.oldApptHistory} />
                                            <Typography variant='body2' className='noteApptHistory' data-testid={`${testid}-departure-appt-history-note`}>{event.stopType === 'pickup' ? t('note_appt_history_pickup') : t('note_appt_history_delivery')}</Typography>
                                        </Box>
                                    </Popper>
                                </ClickAwayListener>}

                            </>
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 3.2 : 3.9} data-testid={`${testid}-departure-carrier-actual-depart-date-time-label`}>{t("carrier_actual_depart_data_time")}</Typography>
                            {
                                !isEditable("actualDepartureTimestampCarrier") ?
                                    <Typography variant='subtitle1' className={event.actualDepartureTimestampCarrierFormatted !== '-'
                                        ? 'textColor'
                                        : event.carrierUpdateLifecycleHealthDeparture === 'RED' || event.isDepartureEventLocked
                                            ? 'textColorRed'
                                            : event.carrierUpdateLifecycleHealthDeparture === 'YELLOW'
                                                ? 'textColorYellow'
                                                : 'textColor'
                                    } data-testid={`${testid}-departure-actual-departure-timestamp-carrier-value`}>
                                        {
                                            event.actualDepartureTimestampCarrierFormatted !== '-' || (!event.isDepartureEventLocked && event.carrierUpdateLifecycleHealthDeparture === 'GREEN')
                                                ? event.actualDepartureTimestampCarrierFormatted
                                                : event.carrierUpdateLifecycleHealthDeparture === '-'
                                                    ? '-'
                                                    : `${t('data_missing')}`
                                        }
                                    </Typography> :
                                    <CustomTextEdit
                                        value={event.actualDepartureTimestampCarrier}
                                        elementKey={"actualDepartureTimestampCarrier"}
                                        type="date"
                                        changeEvent={updateEvent}
                                        eventdata={eventdata}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        setErrors={setErrors}
                                        errors={errors}
                                        testid={`${testid}-departure-actual-departure-timestamp-carrier-input`}
                                    />
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 1.8 : 2.4} data-testid={`${testid}-departure-carrier-actual-depart-reason-code-label`}>{event.stopType === 'pickup' ? t("carrier_actual_pickup_depart_reason_code") : t("carrier_actual_delivery_depart_reason_code")}</Typography>
                            {
                                !isEditable("actualDepartureReasonCodeCarrier") ?
                                    <Typography variant='subtitle1' className={event.actualDepartureReasonCodeDescCarrier !== '-'
                                        ? 'textColor'
                                        : event.carrierUpdateLifecycleHealthDeparture === 'RED' || event.isDepartureEventLocked
                                            ? 'textColorRed'
                                            : event.carrierUpdateLifecycleHealthDeparture === 'YELLOW'
                                                ? 'textColorYellow'
                                                : 'textColor'
                                    } data-testid={`${testid}-departure-actual-departure-reason-code-carrier-value`}>
                                        {
                                            event.actualDepartureReasonCodeDescCarrier !== '-' || (!event.isDepartureEventLocked && event.carrierUpdateLifecycleHealthDeparture === 'GREEN')
                                                ? event.actualDepartureReasonCodeDescCarrier
                                                : event.carrierUpdateLifecycleHealthDeparture === '-'
                                                    ? '-'
                                                    : `${t('data_missing')}`
                                        }
                                    </Typography> :
                                    <CustomTextEdit
                                        value={event.actualDepartureReasonCodeCarrier}
                                        elementKey={"actualDepartureReasonCodeCarrier"}
                                        type="select"
                                        changeEvent={updateEvent}
                                        eventdata={eventdata}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        eventName={event.stopType === 'pickup' ? "carrier_actual_pickup_depart_reason_code" : "carrier_actual_delivery_depart_reason_code"}
                                        setErrors={setErrors}
                                        errors={errors}
                                        testid={`${testid}-departure-actual-departure-reason-code-carrier-input`}
                                    />
                            }
                        </div>
                        <div className='dataBox'>
                            <Typography variant='body2' className='textColor' pr={event.stopType === 'pickup' ? 1.8 : 2.6} data-testid={`${testid}-departure-kc-actual-depart-date-time-label`}>{t("kc_actual_depart_date_time")}</Typography>
                            {
                                !isEditable("actualDepartureTimestampKC") ?
                                    <Typography variant='subtitle1' className='textColor' data-testid={`${testid}-departure-actual-departure-timestamp-kc-value`}>{event.actualDepartureTimestampKCFormatted}</Typography> :
                                    <CustomTextEdit
                                        value={event.actualDepartureTimestampKC}
                                        elementKey={"actualDepartureTimestampKC"}
                                        type="date"
                                        changeEvent={updateEvent}
                                        event={event}
                                        edit={edit}
                                        userGroup={userGroup}
                                        eventdata={eventdata}
                                        setErrors={setErrors}
                                        errors={errors}
                                        departureLocked={event.isDepartureEventLocked}
                                        testid={`${testid}-departure-actual-departure-timestamp-kc-input`}
                                    />
                            }
                        </div>
                    </Box>
                </div>
            </div>
        </>
    )
}

export default StopEvent;